import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron_left",
  "use": "icon-chevron_left-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron_left\"><path d=\"M28.0308 35.3076L16.6924 23.9692L28.0308 12.6116L29.6615 14.2423L19.9538 23.9692L29.6615 33.6769L28.0308 35.3076Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol